import React, { useState, useEffect, useRef } from 'react'
import { Offcanvas, Button } from "react-bootstrap";
import styles from '../header.module.css'
import { Link, withRouter } from 'react-router-dom'
import logo from '../../../../assets/images/logo.png'
import LinkIcon from '../../../../assets/images/homepage/linkicon.svg'
import HeadPhone from '../../../../assets/images/homepage/headphone.svg'
import MenuIcon from '../../../../assets/images/homepage/menuIcon.svg'
import JobPostingIcons from '../../../../assets/images/homepage/JobPostingIcons.svg'
import CrmIcons from '../../../../assets/images/homepage/CrmIcons.svg'
import CampusIcon from '../../../../assets/images/homepage/CampusIcon.svg'
const MainHeader = () => {
    const [show, setShow] = useState(false);

    const handleClose = () => setShow(false);
    const handleShow = () => setShow(true);
    const [isDropdownOpen, setIsDropdownOpen] = useState(false);
    const dropdownRef = useRef(null);

    // Toggle the dropdown
    const toggleDropdown = () => setIsDropdownOpen(!isDropdownOpen);

    // Close dropdown if clicked outside
    useEffect(() => {
        function handleClickOutside(event) {
            if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
                setIsDropdownOpen(false);
            }
        }
        document.addEventListener("mousedown", handleClickOutside);
        return () => document.removeEventListener("mousedown", handleClickOutside);
    }, []);
    return (
        <section>
            <div className={`${styles['bg-top']}`}>
                <div className='container'>
                    <div className='row'>
                        <div className='col-md-12 text-center'>
                            <h5 className={`${styles['top-title']} text-white`}>India's Premier Job Portal – <span className={`${styles['text-yellow']}`}>Discover</span><span className={`${styles['text-blue']}`}>,</span> <span className={`${styles['text-yellow']}`}>Connect</span><span className={`${styles['text-blue']}`}>,</span> <span className={`${styles['text-yellow']}`}>Succeed</span></h5>
                        </div>
                    </div>
                </div>
            </div>
            <nav className='navbar navbar-expand-lg bg-light border-bottom'>
                <div className='container'>
                    <a className='navbar-brand d-flex align-items-center' href='#'>
                        <div className="logo">
                            <Link to='/'><img src={logo} alt="logo" /></Link>
                        </div>
                    </a>
                    <div className={`${styles['desktop-none']}`}>
                        <a href='tel:+917353466466' className={`${styles['ctnva-link']} nav-link d-flex align-items-center`}>
                            <img src={HeadPhone} />
                        </a>
                    </div>
                    <div className={`${styles['desktop-none']}`}>
                        <a href='#' className={`${styles['job-btn']} btn`}><img src={LinkIcon} className='me-1' />Job Seeker</a>
                    </div>
                    <button className='navbar-toggler' type='button' onClick={handleShow}>
                        <img src={MenuIcon} className='img-fluid' />
                    </button>
                    <div className='collapse navbar-collapse' id='navbarContent'>
                        <ul className='navbar-nav me-auto mb-2 mb-lg-0'>
                            <li className={`${styles['ctnav-link']} nav-item dropdown`} ref={dropdownRef}>
                                <a className='nav-link dropdown-toggle' href='#' role='button' onClick={toggleDropdown}>
                                    Products & Services
                                </a>
                                <ul className={`dropdown-menu border-0 shadow-sm ${styles['dropdownct-menu']} ${isDropdownOpen ? 'show' : ''}`}>
                                    <li><a className={`${styles['dropdownct-item']} dropdown-item`} href='#'><img src={JobPostingIcons} className='pe-1' />Job Posting</a></li>
                                    <li><a className={`${styles['dropdownct-item']} dropdown-item`} href='https://jobzshalarecruit.com/'><img src={CrmIcons} className='pe-1' />CRM</a></li>
                                    <li><a className={`${styles['dropdownct-item']} dropdown-item`} href='https://campus.jobzshala.com'><img src={CampusIcon} className='pe-1' />Campus Hiring</a></li>
                                </ul>
                            </li>
                        </ul>
                        <div className='d-flex ms-auto align-items-center'>
                            <a href='tel:+917353466466' className={`${styles['ctnva-link']} nav-link d-flex align-items-center`}>
                                <img src={HeadPhone} /><span><span className={`${styles['top-txt']} ${styles['text-blue']}`}>+91-7353-466-466</span> Indian Sales Support</span>
                            </a>
                            <a href='#' className={`${styles['job-btn']} btn ms-3`}><img src={LinkIcon} className='me-3' />Job Seeker</a>
                        </div>
                    </div>
                </div>
                <div className={`${styles['d-lg-none']}`}>
                    <Button variant="primary" onClick={handleShow}>
                        Open Offcanvas
                    </Button>

                    <Offcanvas show={show} onHide={handleClose} placement="start">
                        <Offcanvas.Header closeButton>
                            <Offcanvas.Title>
                                <div className="logo">
                                    <Link to='/'><img src={logo} alt="logo" /></Link>
                                </div>
                            </Offcanvas.Title>
                        </Offcanvas.Header>
                        <Offcanvas.Body>
                            <ul className='navbar-nav me-auto mb-2 mb-lg-0'>
                                <li className={`${styles['ctnav-link']}`}>
                                    <h5 className={`${styles['ctnav-linka']}`}>
                                        Products & Services
                                    </h5>
                                    <ul className={`${styles['service-list']}`}>
                                        <li><a className='dropdown-item' href='#'><img src={JobPostingIcons} className='pe-1' />Job Posting</a></li>
                                        <li><a className='dropdown-item' href='#'><img src={CrmIcons} className='pe-1' />CRM</a></li>
                                        <li><a className='dropdown-item' href='#'><img src={CampusIcon} className='pe-1' />Campus Hiring</a></li>
                                    </ul>
                                </li>
                            </ul>
                        </Offcanvas.Body>
                    </Offcanvas>
                </div>
            </nav>
        </section>
    )
}


export default MainHeader